// src/hooks/useAuth.js
// Reads signed-in user from SWA's /.auth/me endpoint.
// Also checks group membership for admin role via the API.
import { useState, useEffect } from "react";

export function useAuth() {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/.auth/me")
      .then(res => res.json())
      .then(async data => {
        const principal = data?.clientPrincipal;
        if (!principal) {
          setUser(null);
          return;
        }
        const getClaim = (type) =>
          (principal.claims || []).find(c => c.typ === type)?.val || "";

        // Check admin role via API (group membership checked server-side)
        let isAdmin = false;
        try {
          const roleRes = await fetch("/api/my-role");
          if (roleRes.ok) {
            const roleData = await roleRes.json();
            isAdmin = roleData.isAdmin === true;
          }
        } catch { /* default to non-admin */ }

        setUser({
          name:     getClaim("name")               || principal.userDetails || "",
          upn:      getClaim("preferred_username") || principal.userDetails || "",
          email:    getClaim("email")              || getClaim("preferred_username") || "",
          initials: (getClaim("name") || principal.userDetails || "U")
                      .split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase(),
          isAdmin,
        });
      })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const logout = () => {
    window.location.href = "/.auth/logout?post_logout_redirect_uri=/";
  };

  return { user, loading, logout };
}
